import type { CartConfig } from '#types/config/components/cart'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    editItemCta: 'mt-4 flex items-center gap-2 underlined <lg:hidden text-sm',
    name: 'title-4',
    pricing: 'title-5',
    variantsContainer: 'text-sm c-grey-10 fw-light'
  },
  disableBonusItemPdpLinks: true
} satisfies RecursivePartial<CartConfig['item']>
